import { HYDRATE } from 'next-redux-wrapper';

import { ISeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';

import { InferValueTypes, THydrateAction } from '~/src/store';
import * as actionCreators from '~/src/store/actionCreators/wholesaleCheaper';
import { EWholesaleCheaperTypes } from '~/src/store/actionTypes/wholesaleCheaper';

export interface IWholesaleCheaperState {
    isLoading: boolean,
    wholesaleCheaperData?: ISeasonTicket,
}

export const initialState: IWholesaleCheaperState = {
    isLoading: false,
    wholesaleCheaperData: undefined,
};

type TActions = ReturnType<InferValueTypes<typeof actionCreators>> | THydrateAction;

const wholesaleCheaperData = (state = initialState, action: TActions): IWholesaleCheaperState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state };
        case EWholesaleCheaperTypes.SET_LOADING_STATUS:
            return { ...state, isLoading: action.payload };
        case EWholesaleCheaperTypes.SET_WHOLESALE_CHEAPER_DATA:
            return { ...state, wholesaleCheaperData: action.payload };
        default:
            return state;
    }
};

export default wholesaleCheaperData;
